import introduction from './introduction/index'
import chapter1Content from './chapter1/index'
import { chapter2sub1, chapter2sub2 } from './chapter2/index'

const books = {
  // 书籍的基本信息
  basic: {
    title: '文旌 · 数字教材',
    cover: require('@/assets/images/books/bookExample/book-cover.png'),
    editor: '金企鹅数字教材研发中心',
  },
  // 书籍的目录 需要与内容对应以获取定位
  catalogue: [
    // 引子
    {
      key: 'introduction',
      name: '引子',
    },
    {
      key: 'chapter1',
      name: '第1章 文旌课堂简介',
    },
    {
      key: 'chapter2',
      name: '第2章 文旌数字教材',
      children: [
        {
          key: 'chapter2sub1',
          firstChildKey: 'section2',
          name: '2.1 数字教材概述',
        },
        {
          key: 'chapter2sub2',
          firstChildKey: 'section2.2',
          name: '2.2 文旌数字教材功能介绍',
        },
      ],
    },
    // {
    //   key: 'chapter3',
    //   name: '第3章 文旌数字教材',
    //   isLock: true,
    //   children: [
    //     {
    //       key: 'chapter3sub1',
    //       name: '3.1 数字教材概述',
    //     },
    //     {
    //       key: 'chapter3sub2',
    //       name: '3.2 文旌数字教材功能介绍',
    //     },
    //   ],
    // },
  ],
  content: {
    introduction,
    chapter1: chapter1Content,
    chapter2sub1,
    chapter2sub2,
  },
  fileDownload: [],
}
export default books